/**
 * Copyright (C) 2021 - 2022 Philips Domestic Appliances Holding B.V.
 * All rights are reserved.
 */

export function removeDuplicates<T>(items: Array<T>): Array<T> {
	const itemsSet: Set<T> = new Set(items);
	return Array.from(itemsSet);
}
